// Horse icon — silhueta clara de cabeça de cavalo (estilo cavalo de xadrez).
// Renderiza um cavalo em qualquer tamanho usando currentColor.
export default function Horse({ className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="currentColor"
      className={className}
      {...props}
    >
      {/* Cabeça de cavalo estilo Font Awesome "horse-head" (silhueta cheia) */}
      <path d="M509.8 244.6c-1.5-16.3-10.5-30.9-24.2-39.9L462 189.1V160c0-53-43-96-96-96l-30.4 0-9.7-16.2c-5.6-9.4-14.7-16-25.4-18.4C243.2-1.5 194.4 63.2 179 90.7L96.8 96C43.4 96 0 139.5 0 192.9c0 22.7 8 44.6 22.7 61.9L96 340V464c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48V416H384v48c0 26.5 21.5 48 48 48H496c26.5 0 48-21.5 48-48V317.8L521.7 274.6c-4.6-8.9-9.4-19.7-11.9-30.1zM432 224c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z" transform="translate(-16 0)"/>
    </svg>
  );
}
